import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_KEY_PARAM_NAME } from '../constants';

function preserveApiKey(
    searchParams: URLSearchParams,
    newParamsObj: Record<string, string | string[]>,
): Record<string, string | string[]> {
    const currentApiKey = searchParams.get(API_KEY_PARAM_NAME);
    if (currentApiKey) {
        return {
            ...newParamsObj,
            [API_KEY_PARAM_NAME]: currentApiKey,
        };
    }
    return newParamsObj;
}

export const useSearchParamsWithApiKey = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    type SetSearchParamsOptions = Parameters<typeof setSearchParams>[1];

    const setApiKeySearchParams = useCallback(
        (newParamsObj: Record<string, string | string[]>, options?: SetSearchParamsOptions) => {
            setSearchParams((currentSearchParams) => preserveApiKey(currentSearchParams, newParamsObj), options);
        },
        [setSearchParams],
    );

    return [searchParams, setApiKeySearchParams] as const;
};
